import { TYPES } from "../actions";

const initialState = {
  trustedBankAccounts: [],
  totalCount: 0,
  currentAccount: null,
  searchResults: [],
  loading: false
};

export const tkt1TrustedBankAccountReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS:
      return { 
        ...state, 
        trustedBankAccounts: action.payload.data.data, 
        totalCount: action.payload.data.pagination ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL:
      return { 
        ...state, 
        trustedBankAccounts: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentAccount: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_FAIL:
      return { 
        ...state, 
        currentAccount: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_SUCCESS:
      return { 
        ...state, 
        currentAccount: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_FAIL:
      return { 
        ...state, 
        currentAccount: null,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS:
      return { 
        ...state, 
        searchResults: action.payload.data.data || action.payload.data,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL:
      return { 
        ...state, 
        searchResults: [],
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS:
      return { 
        ...state, 
        trustedBankAccounts: [action.payload.data, ...state.trustedBankAccounts],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS:
      return { 
        ...state, 
        trustedBankAccounts: state.trustedBankAccounts.map(account => 
          account._id === action.payload.data._id ? action.payload.data : account
        ),
        currentAccount: state.currentAccount && state.currentAccount._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentAccount,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS:
      return { 
        ...state, 
        trustedBankAccounts: state.trustedBankAccounts.filter(account => account._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentAccount: state.currentAccount && state.currentAccount._id === action.payload.id 
          ? null 
          : state.currentAccount,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
